import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import {
    articleCard,
    articleCardSm,
    articleImg,
    articleTextWrapper,
    articleTitle,
    articleDesc,
} from './article-card.module.scss';

const ArticleCard = ({ article, hideDescOnXs = true, sizeSm = false }) => {
    const { defaultCategory } = useStaticQuery(DEFAULT_CATEGORY_QUERY);

    if (!article) {
        return null;
    }

    const {
        title,
        description,
        cover_image,
        cover_image_sizing,
        cover_image_background,
    } = article.data;

    const { data: category } = article.data.category?.document
        ? article.data.category.document
        : defaultCategory;
    const articleImgUrl =
        cover_image && cover_image.gatsbyImageData ? cover_image.gatsbyImageData : category.image;
    const articleImgAlt = cover_image && cover_image.alt ? cover_image.alt : title;

    return (
        <article className={`card-item ${articleCard} ${sizeSm && articleCardSm}`}>
            <Link to={`/insights/${article.uid}`} className={`card-content`}>
                {articleImgUrl && getImage(articleImgUrl) && (
                    <GatsbyImage
                        image={getImage(articleImgUrl)}
                        className={`${articleImg}`}
                        objectFit={cover_image_sizing}
                        imgClassName={{ backgroundColor: cover_image_background }}
                        alt={articleImgAlt}
                        title={articleImgAlt}
                        aria-hidden="true"
                    />
                )}
                <div className={`card-text-wrapper ${articleTextWrapper}`}>
                    <h3 className={`card-heading ${articleTitle}`}>{title}</h3>
                    {description && (
                        <p
                            className={`card-desc ${articleDesc} ${
                                hideDescOnXs ? 'sr-only-on-xs' : ''
                            }`}>
                            {description}
                        </p>
                    )}
                </div>
            </Link>
        </article>
    );
};

const DEFAULT_CATEGORY_QUERY = graphql`
    {
        defaultCategory: prismicCategory(uid: { eq: "payroll" }) {
            uid
            data {
                name
                image {
                    gatsbyImageData(width: 600)
                }
            }
        }
    }
`;

ArticleCard.propTypes = {
    article: PropTypes.object.isRequired,
    hideDescOnXs: PropTypes.bool,
    sizeSm: PropTypes.bool,
};

export default ArticleCard;
